import { CompanySchema } from "../types/CompanySchema";
import { OptionsProps } from "../types/Input";

export const parseCompanySchemaToOptions = (
  schema: CompanySchema[]
): OptionsProps[] => schema.map((c) => ({ id: c.id, value: c.name }));
